<div class="gutter">
	<header>
			<h2>{{ pageTitle }}</h2>
	</header>

	<div class="flx-row">

		<ul class="menu flx-row flx-gap-default hide-xs" *ngIf="children.length">
			<ng-template #recursiveList let-children>
				<li *ngFor="let page of children">
					<a [routerLink]="['/'+page?.path]" routerLinkActive="active">{{ page.name }}</a>
					<ul *ngIf="page.children" class="flx-col">
						<ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: page.children }">
						</ng-container>
					</ul>
				</li>
			</ng-template>
			<ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: children }"></ng-container>
		</ul>
		<div class="content gutter gutter-v-half w-100">
			<app-ve *ngIf="pageContent" [content]="pageContent"></app-ve>
		</div>
	</div>
</div>